import {
  useCreateCheckDisbursementMutation,
  useDeleteCheckDisbursementMutation,
  useUpdateCheckDisbursementMutation,
  useUpdateTrackingMutation,
} from 'API/order/escrow/CheckDisbursementAPI';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';

export const useProcessCheck = () => {
  const [onCreateCheck] = useCreateCheckDisbursementMutation();
  const [onUpdateCheck] = useUpdateCheckDisbursementMutation();
  const [onDeleteCheck] = useDeleteCheckDisbursementMutation();
  const [onUpdateCheckTracking] = useUpdateTrackingMutation();
  return (escrowFileId: string, orderId: string, checkForm: ICheckDisbursementFormData) => {
    const { isNew, isDeleting, ...check } = checkForm;

    if (isNew) {
      return onCreateCheck({ orderId, escrowFileId, check });
    }
    if (isDeleting) {
      return onDeleteCheck({ checkId: check.id, orderId });
    }
    if (checkForm.sentAt || checkForm.sentAtDate) {
      return onUpdateCheckTracking({
        trackingNumber: check.trackingNumber,
        shipmentType: check.shipmentType,
        checkId: check.id,
        orderId: orderId,
      });
    } else {
      onUpdateCheckTracking({
        trackingNumber: check.trackingNumber,
        shipmentType: check.shipmentType,
        checkId: check.id,
        orderId: orderId,
      });
      return onUpdateCheck({ check, orderId });
    }
  };
};
